import { render } from "./login.vue?vue&type=template&id=cf8f818c&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=cf8f818c&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod/bijixia-wx-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf8f818c"]])

export default __exports__